import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import Button from "@mui/material/Button";
import Container from '@mui/material/Container';
import {Box, Card, Typography} from "@mui/material";
import {Home, Heart, MoveRight, ChevronRight, CircleCheckBig} from "lucide-react";
import Title from "../../../components/elements/Title";
import AddressChooserFieldHome from "../../../components/address/AddressChooserFieldHome";
import ContactBg1 from '../../../../files/img/bg/one-min.jpg'
import ContactBg2 from '../../../../files/img/bg/two-min.jpg'
import ContactBg3 from '../../../../files/img/bg/three-min.jpg'
import Market from '../../../../files/img/icons/market.png'
import Charity from '../../../../files/img/icons/charity.png'
import Restaurant from '../../../../files/img/icons/restaurant.png'
import App from '../../../../files/img/icons/app.png'
import IOSImg from "../../../../files/img/apps/ios.png";
import AndroidImg from "../../../../files/img/apps/android.png";
import {connect, setStore} from "trim-redux";
import {Link} from 'react-router-dom';
import HomePageSkeleton from "../../../components/loaders/HomePageSkeleton";
import CharitiesSlider from "./charities/CharitiesSlider";


function HomePage({classes, setting}){
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [strings, setStrings] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigation = useNavigate();
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        axios.get(`${defaultVariables.url}/front/home-page`,config)
            .then(response => {
                setData(response.data);
                setStrings(JSON.parse(response.data.page.strings))
                setLoading(false);
            })
            .catch(error => {
                console.error("Ürün verileri alınırken hata oluştu:", error);
                setLoading(false);
            });
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
        setStore(({
            global_menu:"home"
        }))
        loadData();
    },[]);


    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('mainPage')}>
            <div className='home-page'>
                {
                    !!loading ?
                        <HomePageSkeleton/>
                        :
                        <>
                            <section className="home-top-section">
                                <div className="inside-container">
                                    <Container maxWidth="xl" >
                                        <Grid container spacing={4} className="align-center">
                                            <Grid item size={{sm:12,md:7}} className="info">
                                                <Title align="left" variant="h1">{setting?.app_name}</Title>
                                                <Typography>
                                                    {setting?.short_bio}
                                                    <strong>{strings?.tagline}</strong>
                                                </Typography>
                                                <div className="home-field">
                                                    <AddressChooserFieldHome/>
                                                </div>
                                            </Grid>
                                            <Grid item size={{sm:12,md:5}}>
                                                <div className="home-img-holder">
                                                    <img src={ContactBg1} alt="img1" className="small-image"/>
                                                    <img src={ContactBg2} alt="img1" className="small-image"/>
                                                    <img src={ContactBg3} alt="img1" className="large-image"/>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Container>
                                </div>
                            </section>
                            <section className='other-sec'>
                                <Container maxWidth="xl" >
                                    <Grid container spacing={4} justifyContent="center">
                                        <Grid item size={{xs:12,md:5,lg:4}}>
                                            <Box className="introduction-card">
                                                <img src={Restaurant} alt="img1"/>
                                                <Title>{t('restaurant')}</Title>
                                                <Typography>
                                                    {strings?.restaurantsDescription}
                                                </Typography>
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    component={Link}
                                                    to={'/restaurants'}
                                                    endIcon={<ChevronRight/>}
                                                    className="btn"
                                                >
                                                    {strings?.viewRestaurants}
                                                </Button>
                                            </Box>
                                        </Grid>
                                        <Grid item size={{xs:12,md:5,lg:4}}>
                                            <Box className="introduction-card">
                                                <img src={Market} alt="img1"/>
                                                <Title>{t('market')}</Title>
                                                <Typography>
                                                    {strings?.marketsDescription}
                                                </Typography>
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    component={Link}
                                                    to={'/markets'}
                                                    endIcon={<ChevronRight/>}
                                                    className="btn"
                                                >
                                                    {strings?.viewMarkets}
                                                </Button>
                                            </Box>
                                        </Grid>
                                        {/*<Grid item size={{xs:12,md:4}}>
                                            <Box className="introduction-card">
                                                <img src={Charity} alt="img1"/>
                                                <Title>{t('charities')}</Title>
                                                <Typography>
                                                    {strings?.charitiesDescription}
                                                </Typography>
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    component={Link}
                                                    to={'/'}
                                                    endIcon={<ChevronRight/>}
                                                    className="btn"
                                                >
                                                    {strings?.viewCharities}
                                                </Button>
                                            </Box>
                                        </Grid>*/}

                                    </Grid>
                                </Container>
                            </section>
                            <section className='other-sec app-holder'>
                                <Container maxWidth="xl" >
                                    <Grid container spacing={2} className="align-center">
                                        <Grid item size={{xs:12,sm:8,md:7}}>
                                            <div className="info">
                                                <Title color="text" align="left"> {strings?.downloadAppTitle}</Title>
                                                <Typography>{strings?.downloadAppDescription}</Typography>

                                                <div className="download-app">
                                                    {
                                                        !!setting.ios_url &&
                                                        <a  href={setting.ios_url} target="_blank"  rel="noreferrer">
                                                            <img src={IOSImg} alt='ios-app' loading="lazy" width={200}/>
                                                        </a>
                                                    }
                                                    {
                                                        !!setting.android_url &&
                                                        <a href={setting.android_url} target="_blank"  rel="noreferrer">
                                                            <img src={AndroidImg} alt='android-app' loading="lazy" width={200}/>
                                                        </a>
                                                    }
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item size={{xs:12,sm:4,md:5}}>
                                            <div className="app-banner">
                                                <img src={App} alt="img1" className="app"/>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Container>
                            </section>
                            <section className='other-sec be-seller'>
                                <Container maxWidth="xl" >
                                    <Grid container spacing={8} className="align-center">
                                        <Grid item size={{xs:12,lg:6}}>
                                            <div className="seller-home">
                                                <div className="cta">
                                                    <Title component="h2" align="center" color="primary" className="title" >{strings?.becomeSellerTitle}</Title>
                                                    <MoveRight className="lucide-spe"/>
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item size={{xs:12,lg:6}}>
                                            <Typography>
                                                {strings?.sellerDescription}
                                            </Typography>
                                            <div className="feature-holder">
                                                <Box className="feature-box">
                                                    <CircleCheckBig className="lucide-check"/>
                                                    <span>{strings?.feature1}</span>
                                                </Box>
                                                <Box className="feature-box">
                                                    <CircleCheckBig className="lucide-check"/>
                                                    <span>{strings?.feature2}</span>
                                                </Box>
                                            </div>
                                            <div className="feature-holder">
                                                <Box className="feature-box">
                                                    <CircleCheckBig className="lucide-check"/>
                                                    <span>{strings?.feature3}</span>
                                                </Box>
                                                <Box className="feature-box">
                                                    <CircleCheckBig className="lucide-check"/>
                                                    <span>{strings?.feature4}</span>
                                                </Box>
                                            </div>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                                className="btn"
                                                component={Link}
                                                to={'/contact'}
                                            >
                                                {strings?.becomeSellerButton}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Container>
                            </section>
                         {/*   <section className='other-sec'>
                                <Container maxWidth="xl" >
                                    <CharitiesSlider/>
                                </Container>
                            </section>*/}
                        </>
                }
            </div>
        </AppAnimate>
    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(HomePage));